import { Col, Row } from "antd";
import "../../pages/styles/HomeView.scss"
import { RightOutlined } from "@ant-design/icons";

export default function CardsBlueHome({
    leading,
    title,
    subtitle,
    onClick
}) {
    return (
        <Row className="cardsBlueContainer">
            <Col className="column-leading">
                {leading}
            </Col>
            <Col className="column-content">
                {subtitle == undefined ? (
                    <Row style={{ justifyContent: "space-between", alignItems: "center" }}>
                        <h2 style={{ color: "white" }}>{title}</h2>
                        <p style={{ color: "white", cursor: "pointer" }} onClick={onClick}>Ver más <RightOutlined /></p>
                    </Row>
                ) : (
                    <>
                        <h2 style={{ color: "white" }}>{title}</h2>
                        <p style={{ color: "white", fontSize: "12px" }}>{subtitle}</p>
                    </>
                )}

            </Col>
        </Row>
    );
}